import React from 'react';
import { P } from "../style/Tags";

////////CATEGORIES//////////
export const categories = [
    { fullName: 'אנימציה', id: 'animation'},
    { fullName: 'קורסים דיגיטלים', id: 'digitalcourses'},
    { fullName: 'ארועים וכנסים', id: 'events'},
    { fullName: 'פרסומות', id: 'commercials'},
    { fullName: 'קליפים', id: 'clips'},
    { fullName: 'סרטוני תדמית', id: 'promotional'},
    { fullName: 'אחר', id: 'other'},
    { fullName: 'מועדפים', id: 'favorites'},
];

///////////TITLE HOME PAGE TEXT/////////////////
export const titleText=(
<P white>
אנחנו מתמחים בכל תחומי הוידאו והסאונד
      <br/>
  בתיק העבודות שלנו תוכלו למצוא מגוון רחב של
   <br/>
   סרטוני תדמית משובחים, פרסומות, קליפים, הפקות שירים ועוד

</P>)
////////////ABOUT TEXT////////////////////////
export const aboutText=(
    <P white> 
    אולפני צעד הוקמו בשנת 2018 על ידי שני מנהלי החברה יובל צעד ונועם אלישע.
     יובל צעד אחראי על תחום הוידאו בחברה הכולל הפקות, כתיבת תסריטים, עבודה עם תוכנות עריכה הטובות בשוק, ליובל ניסיון רב בתחום ועוסק בו מגיל צעיר מאוד.
     על תחום הסאונד אחראי נועם אלישע בוגר מכללת סלע סקול וכיום אחראי על הפקת שירים ללקוחות, כתיבה, יצירה, הפקת קליפים וכל היוצא בזאת.
      כיום אפשר להגיד שישנה אינטגרציה מלאה בין השניים ושניהם אחראיים על שני התחומים בחברה וממוקצעים בהם ותוך שיתוף פעולה מגיעים בדיוק למוצר הסופי המותאם ללקוח.
      יובל ונועם מכירים מזה שנים וביחד יספקו את השירות הטוב ביותר שאפשר לבקש,כל פרויקט ילווה איתם החל מההתחלה ועד הסיום המוצר המוגמר.
      כיום בחברה ישנם חברות ולקוחות קבועים רבים ומוכרים בניהם קבוצת הפועל באר שבע, תדיראן, מכללות ואוניברסיטאות רבות ועוד.
    אז אל תהססו, כתבו לנו, הצטרפו אלינו וביחד ניצור דברים מדהימים !
  </P>
)




